/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrebidCreditExecutionMode {
  CheckRemainingCredit = 'check_remaining_credit',
  IgnoreRemainingCredit = 'ignore_remaining_credit'
}
